import { QueryResult } from 'react-query';
import { callApi, Controller, getApiUrl, useApi, UseApiOptions } from './useApi';

export interface TerminAttachment {
    zfKaNr: number;
    datum: string;
    text: string;
    file: string;
    oneDriveUrl: string | null;
    updDat?: string;
    updUhr?: number;
    updUser?: string;
}

export interface TerminAttachmentFilter {
    zfKaNr?: number;
    maxRows?: number;
}

export function useTerminAttachmentList(
    filter: TerminAttachmentFilter,
    apiOptions?: UseApiOptions<TerminAttachment[]>,
): QueryResult<TerminAttachment[]> {
    return useApi<TerminAttachment[]>(Controller.terminAttachment + '/list', { filter }, apiOptions);
}

export async function uploadTerminAttachment(file: File, terminAttachment: TerminAttachment): Promise<boolean> {
    const data = new FormData();
    data.append('file', file);
    data.append('terminAttachment.zfKaNr', terminAttachment.zfKaNr.toString());
    data.append('terminAttachment.text', terminAttachment.text || '');
    data.append('terminAttachment.datum', terminAttachment.datum);

    const request: RequestInit = {
        method: 'post',
        mode: 'cors',
        credentials: 'include',
        headers: {},
        body: data,
    };

    const result = await fetch(getApiUrl(Controller.terminAttachment + '/upload'), request);
    return result.status === 200;
}

export async function updateTerminAttachment(terminAttachment: TerminAttachment): Promise<void> {
    return callApi<void>(Controller.terminAttachment + '/update', { terminAttachment });
}

export async function deleteTerminAttachment(terminAttachment: TerminAttachment): Promise<void> {
    return callApi<void>(Controller.terminAttachment + '/delete', { terminAttachment });
}
